<div id="details-page" class="modal" [ngSwitch]="currentIndex">
	<div class="title">{{title}}</div>
	<small class="m-t-4 m-b-4">Find more details about the {{title.toLowerCase()}} below </small>
	<div *ngSwitchCase="0">
		<div class="transaction-details-page" *ngFor="let detail of details">
			<div nz-col nzSpan="24" *ngIf="detail.value">
				<div class="detail-row">
					<span nz-row>
						<span nz-col nzSpan="12">{{detail.label | translate | titlecase}}:</span>
						<span *ngIf="!detail.isAmount && !detail.isDate && !detail.isStatus" nz-col nzSpan="12"
							class="text-bold">
							{{detail.value}}
						</span>
						<span *ngIf="detail.isAmount" nz-col nzSpan="12" class="text-bold">
							{{'moniepoint.currency_symbol'|translate}} {{detail.value|currency}}
						</span>
						<span *ngIf="detail.isStatus" nz-col nzSpan="12" class="text-bold">
							<span [class]="'tag-'+ detail.value?.toLowerCase()">{{detail?.value}}</span>
						</span>
						<span *ngIf="detail.isDate" nz-col nzSpan="12" class="text-bold">
							{{detail.value|date:'medium'}}
						</span>
					</span>
				</div>
			</div>
		</div>
		<div class="m-t-20 text-center text-bold">
			<a (click)="closeModal()">Close</a>
		</div>
	</div>
	<div *ngSwitchCase="1">
		<app-loading loadingText="loading {{title.toLowerCase()}}"></app-loading>
	</div>
	<div class="text-center" *ngSwitchCase="2">
		<div class="m-t-16">
			<svg fill="none" height="90" viewBox="0 0 112 90" width="112" xmlns="http://www.w3.org/2000/svg">
				<circle cx="54.5388" cy="44.7986" fill="#F4803C" r="42.2628" stroke="#FAB417" stroke-width="5.07154" />
				<path clip-rule="evenodd"
					d="M39.6644 28.3151C41.4179 26.5616 44.2608 26.5616 46.0142 28.3151L55.1235 37.4244L64.2328 28.3151C65.9862 26.5616 68.8291 26.5616 70.5826 28.3151L73.247 30.9795L60.9628 43.2637L71.0728 53.3737C72.8263 55.1271 72.8263 57.9701 71.0728 59.7235L68.4084 62.3879L55.1235 49.103L41.8386 62.3879L39.1742 59.7235C37.4207 57.9701 37.4207 55.1271 39.1742 53.3737L49.2842 43.2637L37 30.9795L39.6644 28.3151Z"
					fill="#063A4F" fill-rule="evenodd" />
				<circle cx="4.86941" cy="20.4524" fill="#FAB417" r="4.86941" />
				<circle cx="105.179" cy="66.2242" fill="#FAB417" r="5.8433" />
				<circle cx="16.5545" cy="8.76637" fill="#F4803C" r="2.92165" />
				<circle cx="106.154" cy="49.6687" fill="#F4803C" r="2.92165" />
				<circle cx="94.4666" cy="80.8318" fill="#F4803C" r="2.92165" />
			</svg>
		</div>
		<p class="m-t-6">{{error}}</p>
		<div class="m-t-10">
			<app-custom-submit-button [submitting]="submitting" [block]="true" (submitForm)="reloadDetails()"
				[name]="'Reload Details'"></app-custom-submit-button>
		</div>
	</div>
</div>